var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import Notification from './Notification';
import NotificationBannerApiService from '../services/NotificationBannerApiService';
import '../notification-banner.scss';
const Notifications = () => {
    const [notifications, setNotifications] = useState([]);
    useEffect(() => {
        const getNotifications = () => __awaiter(void 0, void 0, void 0, function* () {
            // Get all actual notifications from the server
            const notificationsFromServer = yield NotificationBannerApiService.get();
            // Filter notifications that user has dismissed
            const dismissedNotificationBannerIds = new Set(JSON.parse(localStorage.getItem('dismissedNotificationBannerIds')));
            const filteredNotifications = notificationsFromServer.filter((notification) => dismissedNotificationBannerIds.has(notification.id) === false);
            setNotifications(filteredNotifications.map((notification) => (Object.assign(Object.assign({}, notification), { show: true }))));
        });
        getNotifications();
    }, []);
    const dismissNotification = (id) => {
        event.preventDefault();
        setNotifications(notifications.map((notification) => notification.id === id
            ? Object.assign(Object.assign({}, notification), { show: false }) : notification));
        // Save dismissed notifications in local storage
        const dismissedNotificationBannerIds = new Set(JSON.parse(localStorage.getItem('dismissedNotificationBannerIds')));
        removeOlderId(dismissedNotificationBannerIds, id);
        dismissedNotificationBannerIds.add(id);
        localStorage.setItem('dismissedNotificationBannerIds', JSON.stringify(Array.from(dismissedNotificationBannerIds)));
    };
    const removeOlderId = (dismissedNotificationBannerIds, currentId) => {
        const [identifier, timestamp] = currentId.split('-');
        dismissedNotificationBannerIds.forEach((dismissedId) => {
            const [dismissedIdentifier, dismissedTimestamp] = dismissedId.split('-');
            if (identifier === dismissedIdentifier) {
                dismissedNotificationBannerIds.delete(dismissedId);
            }
        });
    };
    return (React.createElement("div", { className: "notification-banners" }, notifications.map((notification) => (React.createElement(Notification, { key: notification.id, notification: notification, onDismiss: dismissNotification })))));
};
export default Notifications;
